module.exports = __webpack_public_path__ + "static/daddypossum_characters_wishmastree_01-e4bbb8799fda79b00fcd3d00aaf31be2.jpg";